import "./index.scss";

// Stato con pallino e testo: il colore non è mai l'unico segnale.
// tone: good | warning | critical | neutral
export default function StatusBadge({tone = "neutral", label}) {
	return (
		<span className={"status-badge status-badge--" + tone}>
			<span className="status-badge__dot" />
			{label}
		</span>
	);
}
